import { useEffect, useState, useCallback } from 'react';
import { RegistryAPI } from '../services/RegistryAPI.js';
import { Filters } from '../components/Beehive/FilterBar.js';

export interface Item { 
  type: string; 
  scope: string; 
  name: string;
  version?: string;
  tags?: string[] 
}

export function useRegistry(filters?: Filters) {
  const [items, setItems] = useState<Item[]>([]);

  const refetch = useCallback(async () => {
    setItems(await RegistryAPI.list());
  }, []);

  useEffect(() => { void refetch(); }, [refetch]);

  const filtered = filters
    ? items.filter(i =>
        (!filters.type  || i.type  === filters.type)  &&
        (!filters.scope || i.scope === filters.scope) &&
        (!filters.tag   || i.tags?.includes(filters.tag))
      )
    : items;

  return { items: filtered, refetch };
}
